import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EcdStates } from '../../root/ecd-model';
import { getEcdEpiProps, setMailSettingsProps } from '../ducks/epi-api';
import { EcdRootPage } from '../models/ecd-page-models';
import { EcdMailSettingsProps } from '../models/epi-model';

export function useEpiMailSettingsLoaded() : boolean {
    return useSelector<EcdStates, boolean>(state => state.epiProps?.mailSettingsState?.mailSettingsLoaded);
}

export function useEpiMailSettings() : EcdMailSettingsProps {

    const ecdPageContentId: string = (useSelector<EcdStates, any>(state => state.epiProps?.contentState?.epiContent) as EcdRootPage)?.mailSettingId;
    const language = useSelector<EcdStates, string>(state => state.globalization?.currentlanguage);
    const stateData = useSelector<EcdStates, EcdMailSettingsProps>(state => state.epiProps?.mailSettingsState?.mailSettings);
    const contentLoaded = useEpiMailSettingsLoaded();    

    const dispatch = useDispatch();

    useEffect(() => {
        if (!contentLoaded && ecdPageContentId){
            dispatch(getEcdEpiProps(dispatch, ecdPageContentId, {}, language, false, setMailSettingsProps));
        }
    }, [contentLoaded, ecdPageContentId]);

    return stateData;
}